import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M5 4H14.0801C14.9559 4 15.788 4.38269 16.3579 5.04763L21.7593 11.3492C22.0802 11.7237 22.0802 12.2763 21.7593 12.6508L16.3579 18.9524C15.788 19.6173 14.9559 20 14.0801 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4ZM19.6829 12L14.8394 6.34921C14.6494 6.12756 14.3721 6 14.0801 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H14.0801C14.3721 18 14.6494 17.8724 14.8394 17.6508L19.6829 12Z" />,
  'Label'
);
